function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 3C1.75 1.75736 2.75736 0.75 4 0.75H16C17.2426 0.75 18.25 1.75736 18.25 3V11C18.25 12.2426 17.2426 13.25 16 13.25H4C2.75736 13.25 1.75 12.2426 1.75 11V3Z",
  stroke: "#249AF3",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.93934 10.9393L7.46967 11.4697L6.93934 10.9393L5 12.8787L4.06066 11.9393C3.47487 11.3536 2.52513 11.3536 1.93934 11.9393C1.35355 12.5251 1.35355 13.4749 1.93934 14.0607L3.93934 16.0607C4.52513 16.6464 5.47487 16.6464 6.06066 16.0607L9.06066 13.0607C9.64645 12.4749 9.64645 11.5251 9.06066 10.9393L8.53033 11.4697L9.06066 10.9393C8.47487 10.3536 7.52513 10.3536 6.93934 10.9393Z",
  fill: "#249AF3",
  stroke: "#F6FBFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPrepFundingEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepFundingEmailIcon);
export default __webpack_public_path__ + "static/media/PrepFundingEmailIcon.dad19598.svg";
export { ForwardRef as ReactComponent };